export const iconFontAwesomeShoppingCartArrowDown = (
	<i className="fa-solid fa-cart-arrow-down"></i>
);
